import * as React from "react"
import { Skeleton } from "@mui/material"

import { TitleWithPopover, AppTableSeeker } from "@components"
import { STOCK_ROUTES } from "@constants"
import { useShareUrl } from "@hooks"
import { endDate } from "@signals"
import { prevEndDate } from "@signals/filters"
import { usePricingDiscountRoleConfig } from "Pages/Pricing/PriceDiscount/@hooks"
import { retailerColumn, skuColumn, stockStatusColumn, pricesColumn, diffColumn  } from "./columns";
import PriceDiscountTopMarketChangesTableActions from "../TableActions"
import PricingDiscountTableTitleLink from "../../TableTitleLink"


export default function PriceTopMarketChangesStockTable({data, isLoading, selectedCountry, countries, handleSelectedCountry}) {

	const { buildShareParams } = useShareUrl()
	// The MARKETPLACES branches are gone rather than ported: that role is out of scope for the
	// migration and is not coming back, so `sellerColumn` is unreachable and the four price columns
	// are unconditional. Reading `isMarketplacesUser` from the hook would have kept working by
	// accident — it would come back `undefined` — but the columns would depend on a missing value.
	const { isRetailerUser } = usePricingDiscountRoleConfig()

	if (isLoading) return <Skeleton variant="rectangular" height={500} />

	return <AppTableSeeker
		title={
			<PricingDiscountTableTitleLink 
			title="Top 20 Stock Changes" 
			tooltip="Go to Stock Changes"
			url={`${STOCK_ROUTES.STOCK_CHANGES_PATH}?sp=${buildShareParams({currentSingleDate: endDate.value, prevSingleDate: prevEndDate.value})}&launch=true`} 
		/>}
		data={data}
		columns={[
			retailerColumn(),
			...skuColumn(),
			stockStatusColumn('prevStock', 'Previous Stock Status', 'prevStockColor', 'prevNumVariants'),
			stockStatusColumn('stock', 'Stock Status', 'stockColor', 'numVariants'),
			...isRetailerUser ? [pricesColumn('myListPrice', 'My Min List Price')] : [],
			pricesColumn('price', 'Price'),
			pricesColumn('myPrice', isRetailerUser ? 'My Min Current Price' : 'RRSP'),
			diffColumn(isRetailerUser ? 'Diff vs My Min Current Price' : 'Diff vs RRSP')
		]}
		options={{
			search: false,
			print: false,
			filter: false,
			viewColumns: false,
			rowsPerPage: 5,
			rowsPerPageOptions: [5, 10],
			customToolbar: () => {
				return <PriceDiscountTopMarketChangesTableActions
					selectedCountry={selectedCountry}
					countries={countries}
					onClick={handleSelectedCountry}
				/>
			}
		}}
		textLabels= {{
			body: {
				noMatch: 'There doesn’t seem to be much variation in stock levels for the chosen dates.'
			}
		}}
	/>
}